import React from "react";

import Icon from "./Icon";

class Loader extends React.Component {

    render() {
        return <Icon
            icon="sync"
            fixedWidth
            spin
            {...this.props}
        />;
    }

}

export default Loader;


// WEBPACK FOOTER //
// ./src/components/ui/Loader.js